module.exports = __webpack_public_path__ + "static/img/07.1df2761.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/health/07.png
// module id = 3vxk
// module chunks = 1